import iconSquare from '@/assets/brand/icon-square.jpeg'
import logoWhite from '@/assets/brand/logo-white.jpeg'
import styles from './MinistryBrand.module.css'

type MinistryBrandVariant = 'mark' | 'lockup'

interface MinistryBrandProps {
  variant?: MinistryBrandVariant
  className?: string
}

/**
 * Renders the existing Ministerul Fericirii și Ideilor Bune identity assets.
 * `mark` = compact emblem only (header, sidebar footer).
 * `lockup` = full horizontal wordmark (login screen, About page).
 */
export function MinistryBrand({ variant = 'mark', className }: MinistryBrandProps) {
  if (variant === 'lockup') {
    return (
      <img
        src={logoWhite}
        alt="Ministerul Fericirii și Ideilor Bune"
        className={[styles.lockup, className].filter(Boolean).join(' ')}
      />
    )
  }

  return (
    <img
      src={iconSquare}
      alt="Ministerul Fericirii și Ideilor Bune"
      className={[styles.mark, className].filter(Boolean).join(' ')}
    />
  )
}
